// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  position: relative;
  width: 100%;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(10px);
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo-container {
  display: flex;
  align-items: center;
}

.logo {
  height: 40px;
  width: auto;
}

.contact-info {
  display: flex;
  gap: 2rem;
  align-items: center;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  text-decoration: none;
  color: white;
}

.contact-icon {
  width: 24px;
  height: 24px;
}

.contact-text {
  display: flex;
  flex-direction: column;
}

.contact-label {
  font-size: 0.75rem;
  opacity: 0.8;
  font-family: 'Josefin Sans', sans-serif;
}

.contact-value {
  font-size: 1rem;
  font-family: 'Josefin Sans', sans-serif;
}

@media (max-width: 768px) {
  .header-content {
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
  }

  .contact-info {
    flex-direction: column;
    gap: 1rem;
  }
} `, "",{"version":3,"sources":["webpack://./src/styles/Header.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;AACF","sourcesContent":[".header {\n  position: relative;\n  width: 100%;\n  z-index: 999;\n  background-color: rgba(0, 0, 0, 0.8);\n  backdrop-filter: blur(10px);\n}\n\n.header-content {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 1rem 2rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.logo-container {\n  display: flex;\n  align-items: center;\n}\n\n.logo {\n  height: 40px;\n  width: auto;\n}\n\n.contact-info {\n  display: flex;\n  gap: 2rem;\n  align-items: center;\n}\n\n.contact-item {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  text-decoration: none;\n  color: white;\n}\n\n.contact-icon {\n  width: 24px;\n  height: 24px;\n}\n\n.contact-text {\n  display: flex;\n  flex-direction: column;\n}\n\n.contact-label {\n  font-size: 0.75rem;\n  opacity: 0.8;\n  font-family: 'Josefin Sans', sans-serif;\n}\n\n.contact-value {\n  font-size: 1rem;\n  font-family: 'Josefin Sans', sans-serif;\n}\n\n@media (max-width: 768px) {\n  .header-content {\n    flex-direction: column;\n    gap: 1rem;\n    padding: 1rem;\n  }\n\n  .contact-info {\n    flex-direction: column;\n    gap: 1rem;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
